import { PromoCodeRedemption } from '@zerops/models/promo-code';
import { PendingPromoCode } from './promo-code-base.util';

export class PromoCodeBaseState {
  redemptions: PromoCodeRedemption[];
  // The redemption produced by the most recent redeem in this session — the
  // one and only place the amount is ever shown. Separate from `redemptions`
  // because the history list is also populated on page load, where there is
  // nothing to reveal.
  lastRedemption: PromoCodeRedemption;
  // The code sent with a signup, awaiting its post-signup reveal.
  submitted: PendingPromoCode;
  // What the flow endpoint said about the code currently in hand.
  resolvedFlow: { code: string; appliesToTopUp: boolean; };

  constructor() {
    this.redemptions = undefined;
    this.lastRedemption = undefined;
    this.submitted = undefined;
    this.resolvedFlow = undefined;
  }
}
